import { motion } from "framer-motion";
import { EASE } from "@/lib/scroll";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

const lineV = {
  hidden: { y: "110%" },
  show: (d) => ({ y: "0%", transition: { duration: 1.1, ease: EASE, delay: d } }),
};

export const MaskLines = ({ lines, className = "", delay = 0, inView = false }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(inView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" })}
  >
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.06em]">
        <motion.span className="block" variants={lineV} custom={delay + i * 0.1}>{line}</motion.span>
      </span>
    ))}
  </motion.span>
);

export const Eyebrow = ({ children, light = false }) => (
  <p className={`inline-flex items-center gap-2 rounded-full border px-3.5 py-1.5 text-xs font-medium uppercase tracking-[0.16em] ${light ? "border-white/20 text-[#D8E6C4]" : "border-[#111511]/10 bg-white text-[#2F5D3A]"}`}>
    <span className={`w-1.5 h-1.5 rounded-full ${light ? "bg-[#9CC26A]" : "bg-[#5E8C3A]"}`} />
    {children}
  </p>
);

export const SectionHead = ({ eyebrow, lines, text, light = false, id }) => (
  <div className="grid lg:grid-cols-12 gap-8 items-end">
    <div className="lg:col-span-7">
      <Eyebrow light={light}>{eyebrow}</Eyebrow>
      <h2 id={id} className={`mt-6 font-head font-semibold text-[2.4rem] sm:text-5xl lg:text-6xl tracking-[-0.035em] leading-[1.02] ${light ? "text-white" : "text-[#111511]"}`}>
        <MaskLines inView lines={lines} />
      </h2>
    </div>
    {text && (
      <Reveal className="lg:col-span-5" delay={0.1}>
        <p className={`text-base sm:text-lg leading-relaxed ${light ? "text-[#C9CEC6]" : "text-[#5B615A]"}`}>{text}</p>
      </Reveal>
    )}
  </div>
);
